import React from 'react';
import './styles.scss';
import BackToSetup from '../BackToSetup';
import { getSetup } from '../../utils/getSetup.ts';

export default function Loading({
    text,
}: {
    text?: string;
}): React.ReactElement {
    const setup = getSetup();
    const orientationFromParams = new URLSearchParams(
        window.location.search
    ).get('orientation');
    if (orientationFromParams)
        localStorage.setItem('orientation', orientationFromParams);
    const orientation =
        orientationFromParams || localStorage.getItem('orientation') || '';
    return (
        <div className='loading-page'>
            <div className={`wrapper ${orientation}`}>
                <div className='loading-spinner' />
                {text && <p className='caching-progress'>{text}</p>}
                {setup?.brand && <BackToSetup />}
            </div>
        </div>
    );
}
